import styled, { css } from 'styled-components';

export const Body = styled.div`
  ${({ theme }) => css`
    background: ${theme.colours.bg};
    color: ${theme.colours.fg};
  `};

  transition:
    background 200ms,
    color 200ms;

  width: 100vw;
  height: 100vh;

  @supports (height: 100dvh) {
    height: 100dvh;
  }

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  overflow-y: auto;

  align-items: center;
  justify-content: center;

  scrollbar-color: ${({ theme }) => theme.colours.accent} transparent;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colours.accent};
    border-radius: 20px;
    border: transparent;
  }
`;
